import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ContextMenu from '@/components/context-menu'
import { colors, fontSizes, breakpoints } from '@/styles'
import { getImageUrl } from '@/utils/image'

const ListingImageContainer = styled.div`
  user-select: none;
  object-fit: cover;
  height: 200px;
  width: 200px;
  position: relative;
  margin: 0;

  &:after {
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    pointer-events: none;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    width: 156px;
    height: 156px;
  }
`

const ListingImageLabel = styled.h3`
  color: ${colors.white};
  font-size: ${fontSizes.regular};
  letter-spacing: -0.39px;
  line-height: 22px;
  text-shadow:
    1px 2px 1px rgba(0, 0, 0, 0.9),
    1px 1px 7px #000,
    1px 1px 7px #000;
  position: absolute;
  width: 100%;
  left: 0;
  top: 10px;
  text-align: center;
`

const ListingImage = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['src'].includes(prop) && defaultValidatorFn(prop)
})`
  border-radius: 6px;
  height: 200px;
  width: 200px;

  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  background-size: cover;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    width: 156px;
    height: 156px;
  }
`

const ImageComponent = ({
  data: image,
  setCover,
  remove,
  listeners,
  attributes,
  style,
  ...rest
}) => {
  const { t } = useTranslation()
  const isCover = image.tag === 'cover_photo'
  const contextMenuItems = [
    ...(isCover
      ? []
      : [
          {
            onClick: () => setCover(image),
            label: t('b.listing.edit.image_upload_set_cover_photo.button', 'Set as cover photo')
          }
        ]),
    {
      onClick: () => remove(image),
      label: t('common.remove', 'Remove'),
      color: colors.red
    }
  ]
  return (
    <ListingImageContainer key={image.id}>
      {isCover && (
        <ListingImageLabel>
          {t('b.listing.edit.image_upload_cover_photo.text', 'Cover Photo')}
        </ListingImageLabel>
      )}
      <ContextMenu items={contextMenuItems} />
      <ListingImage
        style={style}
        {...listeners}
        {...attributes}
        src={getImageUrl(image.aws_s3_key, { width: 200, height: 200 })}
      />
    </ListingImageContainer>
  )
}

export default ImageComponent
